// extracted by mini-css-extract-plugin
export default {"attachments":"Attachments_attachments__LNy9-"};